// extracted by mini-css-extract-plugin
module.exports = {"section":"LanguageSelector_section__3-spb"};